/**
 * @generated SignedSource<<bb1f83d308dc6be78156c45b1f3afe5e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cpaId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VendorCommProgramAppDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteCpAppTPayload",
        "kind": "LinkedField",
        "name": "deleteCpAppTByCpaId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CpAppT",
            "kind": "LinkedField",
            "name": "cpAppT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VendorCommProgramAppDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteCpAppTPayload",
        "kind": "LinkedField",
        "name": "deleteCpAppTByCpaId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CpAppT",
            "kind": "LinkedField",
            "name": "cpAppT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "28ed444de1f99c7014f169552463f538",
    "id": null,
    "metadata": {},
    "name": "VendorCommProgramAppDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation VendorCommProgramAppDeleteMutation(\n  $input: DeleteCpAppTByCpaIdInput!\n) {\n  deleteCpAppTByCpaId(input: $input) {\n    cpAppT {\n      cpaId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "d8c684822a2960b7d06c7779862bcf2c";

module.exports = node;
